var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_800_1099)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49923 12.9757C5.57969 12.8952 5.69033 12.8483 5.80767 12.8483H16.4489C16.6433 12.8483 16.7405 13.083 16.6031 13.2205L14.501 15.3225C14.4205 15.403 14.3099 15.4499 14.1926 15.4499H3.55136C3.35691 15.4499 3.25968 15.2153 3.39714 15.0778L5.49923 12.9757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49923 5.1274C5.58304 5.04694 5.69368 5 5.80767 5H16.4489C16.6433 5 16.7405 5.23468 16.6031 5.37214L14.501 7.47423C14.4205 7.55469 14.3099 7.60163 14.1926 7.60163H3.55136C3.35691 7.60163 3.25968 7.36694 3.39714 7.22949L5.49923 5.1274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.501 9.02713C14.4205 8.94667 14.3099 8.89973 14.1926 8.89973H3.55136C3.35691 8.89973 3.25968 9.13442 3.39714 9.27187L5.49923 11.374C5.57969 11.4544 5.69033 11.5014 5.80767 11.5014H16.4489C16.6433 11.5014 16.7405 11.2667 16.6031 11.1292L14.501 9.02713Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_800_1099",
    x1: 15.7172,
    y1: -46.1309,
    x2: -29.5333,
    y2: -29.2208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 10.4501,
    fill: "white",
    transform: "translate(3.33325 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolLogo);
export default __webpack_public_path__ + "static/media/solLogo.30aaa7ef0c7bfe8a5f1914686997f906.svg";
export { ForwardRef as ReactComponent };